import React, {Component, Fragment} from "react";
import Slider from "react-slick";
import Link from 'next/link'
import { Carousel } from 'antd';

import {ASSET_URL} from "../../../../../config"
import {isRtl} from "../../../../../locales";

class Hero2 extends Component {
    render() {
        const context=this.props.context
        const {org,config}=context

        var settings = {
            dots: true,
            arrows: true,
            speed: 1200,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2500,
            fade: true,
            rtl:false
        };

        if(config["hero.carousel"].length===1){
            settings.dots=false
            settings.arrows=false
            settings.autoplay=false
        }

        return (
            <section dir={"ltr"} className="hero hero-style-1">
                <div className="hero-slider">
                    <Slider {...settings}>

                        {config["hero.carousel"].map((item,index)=>{
                            return (
                                <Fragment>
                                    <div className={"slide"} style={{width:"100%",background:"url('"+ASSET_URL+item.image+"') center center/cover no-repeat"}}>
                                        <div className="container">
                                            <div className="row">
                                                <div className="col col-lg-8 offset-lg-2 col-md-12 slide-caption">
                                                    <div className="slide-top">
                                                        <span>{org.name}</span>
                                                    </div>
                                                    <div className="slide-title">
                                                        <h2>{item.title}</h2>
                                                    </div>
                                                    {item.textLink && item.link &&(
                                                        <div className="btns">
                                                            <Link href={item.link}><span className="theme-btn" style={{cursor:"pointer"}}>{item.textLink}</span></Link>
                                                        </div>
                                                    )}

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Fragment>
                            )
                        })}
                    </Slider>
                </div>
            </section>
        );
    }
}
export default Hero2;
